/* global window document */

import React, {Component} from 'react';
import {Link} from 'gatsby';
import classnames from 'classnames';

import styles from './styles.module.css';
import logo from './logo.svg';
import reset from './reset.svg';
import share from './share.svg';

class Header extends Component {
    state = {
        shareOpen: false,
        copied: false,
    };

    toggleShare = () => {
        const {shareOpen} = this.state;
        this.setState({shareOpen: !shareOpen});
    }

    copy = () => {
        this.input.select();
        document.execCommand('copy');
        this.setState({copied: true}, () => {
            setTimeout(() => this.setState({copied: false}), 4000);
        });
    }

    render() {
        const {shareOpen, copied} = this.state;

        return (
            <header className={styles.header}>
                <Link to="/" className={styles.logo}><img src={logo} alt="Amazon" /></Link>
                <div
                    className={styles.share}
                    onClick={this.toggleShare}
                    onKeyDown={
                        (evt) => (evt.keyCode === 13 || evt.keyCode === 32) && this.toggleShare()
                    }
                    role="button"
                    tabIndex={0}
                >
                    Share
                    <img src={share} alt="" />
                </div>
                <Link to="/questions" className={styles.restart}>
                    <img src={reset} alt="" />
                    Restart
                </Link>
                <div
                    className={classnames(
                        styles.sharePanel, {
                            [styles.open]: shareOpen,
                        },
                    )}
                >
                    <strong>Link:</strong>
                    <input
                        type="text"
                        value={typeof window !== 'undefined' ? window.location.href : ''}
                        onFocus={(evt) => evt.target.select()}
                        ref={(el) => {
                            this.input = el;
                        }}
                        readOnly
                    />
                    <div
                        className={classnames(styles.copy, {[styles.copied]: copied})}
                        onClick={this.copy}
                        onKeyDown={
                            (evt) => (evt.keyCode === 13 || evt.keyCode === 32) && this.copy()
                        }
                        role="button"
                        tabIndex={0}
                    >
                        {copied ? 'Copied' : 'Copy'}
                    </div>
                </div>
            </header>
        );
    }
}

export default Header;
